export enum InventoryArticleStatus {
    Dead = "Dead",
    Ongoing = "Ongoing",
}

export interface InventoryArticleDto {
    id: number;
    code: string;
    name: string;
    isPost: boolean;
    origCountry: string;
    tarCode: string;
    shp: number;
    bat: number;
    dtd: number;
    ret: number;
    wt: number;
    status: string;
    codeAndName: string;
    packageItems: InventoryArticlePackageItemDto[];
    isPackage: boolean;
    saleArticles: SaleArticleDto[];
    availableStock: number | null;
    isInvalid: boolean;
    showOnInvoice: boolean;
    showPackageContent: boolean;
}

export interface InventoryArticlePackageItemDto {
    id: number;
    inventoryArticleId: number;
    quantity: number;
}

export interface SaleArticleDto {
    id: number;
    code: string;
    name: string;
    price: number;
    baseQuantity: number;
    vatPercent: number;
    moVatPercent: number;
    moArticle: boolean;
    isInvalid: boolean;
}

export interface SaleArticleDetailDto {
    id: number;
    saleArticleId: number;
    projectId: number;
    projectName: string;
    price: number;
    useDiscount: boolean;
    categories: string;
    articleName: string;
    isOnlyForAuto: boolean;
    packageType: number | null;
    packageItems: SaleArticleDetailPackageItemDto[];
    isInvalid: boolean;
}

export interface SaleArticleDetailPackageItemDto {
    id: number;
    saleArticleId: number;
    quantity: number;
    price: number;
}

export interface SaleArticleDetailProductDto {
    id: number;
    code: string;
    codeAndName: string;
    projects: SaleArticleDetailProjectDto[];
}

export interface SaleArticleDetailProjectDto {
    id: number;
    codeAndName: string;
}
